export const SELECTION_LIMIT = 3000
export const IMPORTING_DEVICE_LIMIT = 250
export const UPLOADING_DEVICE_LIMIT = 1
export const IMPORT_FROM_FMS_UPLOADING_DEVICE_LIMIT = 250
export const BATCH_UPLOADING_DEVICE_LIMIT = 1

export const IMPORT_FILE_LOAD_HANDLER_TYPE = 'import'
export const IMPORT_OCPP_FILE_LOAD_HANDLER_TYPE = 'import-ocpp'
export const TRANSFER_FILE_LOAD_HANDLER_TYPE = 'transfer'
export const TRANSFER_FROM_FILE_LOAD_HANDLER_TYPE = 'transferFromFile'
export const BATCH_FILE_LOAD_HANDLER_TYPE = 'uploadBatch'

export const CHECKBOX_COLUMN_WIDTH = 58

export const actionTypes = {
  IMPORT_ACTION: 1,
  UPLOAD_ACTION: 2,
  TRANSFER_FROM_FILE_ACTION: 3,
  UPLOAD_BATCH_ACTION: 4,
  IMPORT_OCPP_ACTION: 5
}

export const UPLOAD_STATUS_CONFIG = {
  SUCCESS: {
    singleMessage: 'was uploaded to Device Registry.',
    pluralMessage: 'were uploaded to Device Registry.'
  },
  DEVICE_ALREADY_EXISTS: {
    singleMessage: 'already exists there.',
    pluralMessage: 'already exists there.'
  },
  WRONG_DEVICE_CERTIFICATE: {
    singleMessage: 'was not uploaded, Certificate is missing.',
    pluralMessage: 'were not uploaded, Certificate is missing.'
  },
  MISSING_DEVICE_UUID: {
    singleMessage: 'device was not uploaded, Chip_ID is missing.',
    pluralMessage: 'devices were not uploaded, Chip_ID is missing.'
  },
  MISSING_CUSTOMER: {
    singleMessage: 'was not transferred, Customer ID is missing',
    pluralMessage: 'were not transferred, Customer ID is missing'
  },
  UNKNOWN_CUSTOMER: {
    singleMessage: 'was not uploaded, Customer_ID is missing in Customers database.',
    pluralMessage: 'were not uploaded, Customer_ID is missing in Customers database.'
  },
  FAILED_TO_PROVISION_CERTIFICATE: {
    singleMessage: 'was not uploaded, Certificate provision troubles.',
    pluralMessage: 'were not uploaded, Certificate provision troubles.'
  },
  NO_EXISTING_DEVICE_FOUND: {
    singleMessage: 'was not found.',
    pluralMessage: 'were not found.'
  },
  DEVICE_HAS_THE_SAME_CUSTOMER: {
    singleMessage: 'has the same customer.',
    pluralMessage: 'have the same customer.'
  }
}

export const TRANSFER_STATUS_CONFIG = {
  ERROR: 'Please select chargers that belong to one customer and the auto transfer is available for this customer.'
}

export const TRANSFER_FROM_FILE_STATUS_CONFIG = {
  SUCCESS: {
    singleMessage: 'was transferred successfully.',
    pluralMessage: 'were transferred successfully.'
  },
  DEVICE_ALREADY_EXISTS: {
    singleMessage: 'already exists there.',
    pluralMessage: 'already exists there.'
  },
  WRONG_DEVICE_CERTIFICATE: {
    singleMessage: 'was not transferred, device certificate is missing.',
    pluralMessage: 'were not transferred, device certificates are missing.'
  },
  MISSING_DEVICE_UUID: {
    singleMessage: 'Device was not transferred, device UUID is missing.',
    pluralMessage: 'Devices was not transferred, device UUID is missing'
  },
  MISSING_CUSTOMER: {
    singleMessage: 'was not transferred, Customer ID is missing',
    pluralMessage: 'were not transferred, Customer ID is missing'
  },
  UNKNOWN_CUSTOMER: {
    singleMessage: 'was not transferred, Customer ID doesn\'t exist.',
    pluralMessage: 'were not transferred, Customer IDs don\'t exist.'
  },
  FAILED_TO_PROVISION_CERTIFICATE: {
    singleMessage: 'was not transferred, Certificate provision troubles.',
    pluralMessage: 'were not transferred, Certificate provision troubles.'
  },
  NO_EXISTING_DEVICE_FOUND: {
    singleMessage: 'was not transferred, device is not found in the Device Registry.',
    pluralMessage: 'were not transferred, devices are not found in the Device Registry.'
  },
  DEVICE_HAS_THE_SAME_CUSTOMER: {
    singleMessage: 'was not transferred, new Customer ID is the same as current one.',
    pluralMessage: 'were not transferred, new Customer ID is the same as current one.'
  }
}
